export default {
    page_title: "허브 통계",
};
